import { request } from "./api";

export type Role = "owner" | "editor" | "viewer";

export interface CurrentUser {
  id: string;
  username: string;
  tenant_id: string;
  tenant_name: string;
  role: Role;
  is_platform_admin: boolean;
  /**
   * True when this session was injected by the backend's anonymous middleware
   * (ANONYMOUS_TENANT_ID env set, no cookie present).
   *
   * CONSUMED ONLY BY THE SIDEMENU/TOPBAR COMPONENT. Any other code reading this
   * field violates the EPIC-7 isolation contract — reject in code review.
   */
  is_anonymous: boolean;
}

export async function login(username: string, password: string): Promise<CurrentUser> {
  return request<CurrentUser>("/auth/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
}

export async function logout(): Promise<void> {
  await request<{ ok: boolean }>("/auth/logout", { method: "POST" });
}

export async function fetchMe(): Promise<CurrentUser> {
  return request<CurrentUser>("/auth/me");
}

export async function changePassword(
  currentPassword: string,
  newPassword: string,
): Promise<void> {
  await request<{ ok: boolean }>("/auth/change-password", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      current_password: currentPassword,
      new_password: newPassword,
    }),
  });
}
